import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { FileText, ArrowLeft } from "lucide-react";
import { useContentList } from "../hooks/useContentData";
import MD from "../components/Markdown";

/**
 * Pagina legal/informativa generica.
 * Lee la lista `legal.pages` del CMS y muestra la que coincide con :slug.
 */
const LegalPage = () => {
  const { slug } = useParams();
  const { items } = useContentList("legal.pages", []);

  const page = (items || []).find((p) => p && p.slug === slug);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "instant" : "auto" });
  }, [slug]);

  return (
    <main className="bg-[#0a0a0d] min-h-screen pt-32 pb-20">
      <div className="max-w-3xl mx-auto px-6 md:px-10">
        <Link to="/" className="inline-flex items-center gap-2 text-xs text-[#b8b3a8] hover:text-[#d4a843] mb-6">
          <ArrowLeft className="w-3.5 h-3.5" /> Volver al inicio
        </Link>

        {page ? (
          <article>
            <div className="ornament"><span>{page.eyebrow || "Legal"}</span></div>
            <h1 className="section-title mt-3 text-3xl md:text-4xl mb-8 flex items-center gap-3">
              <FileText className="w-7 h-7 text-[#d4a843] shrink-0" /> {page.title}
            </h1>
            <div className="glass rounded-sm p-6 md:p-8">
              <MD>{page.body}</MD>
            </div>
          </article>
        ) : (
          <div className="glass rounded-sm p-10 text-center text-[#b8b3a8]">
            <FileText className="w-10 h-10 text-[#6f6c66] mx-auto mb-4" />
            <p>Esta página no existe o aún no fue configurada.</p>
          </div>
        )}
      </div>
    </main>
  );
};

export default LegalPage;
